<template>
  <UFooter class="border-t border-neutral-200 dark:border-neutral-700">
    <template #left>
      <p class="text-muted text-sm">
        Cloudnine Media GmbH Copyright © {{ new Date().getFullYear() }}
      </p>
    </template>

    <template #right>
      <p class="text-muted text-sm">Anberg 1a, 20459 Hamburg</p>
    </template>
  </UFooter>
</template>

<script lang="ts" setup></script>

<style></style>
